import { Controller } from "stimulus"
import Trix from "trix"
import axios from "axios"

export default class extends Controller {
  initialize(){
    this.editor = this.element.querySelector('trix-editor').editor
  }
  
  connect(){
    this.tableCounter = 0
    this.calculateAllTableCounter()
    this.disableAttachTableButton()
    this.createCountMessageDiv()
    this.setCount(this.editor.element);

    this.editor.element.addEventListener("trix-change", (e)=> this.setCount(e.target));
    this.editor.element.addEventListener("trix-attachment-add", (e)=> {
      this.incrementTableCounter()
      
      // prevent copy and past table
      if(this.tableCounter > 1){
        this.editor.composition.removeAttachment(e.attachment)
      }
    });
    this.editor.element.addEventListener("trix-attachment-remove", ()=> this.decrementTableCounter());
  
  }

  calculateAllTableCounter(){
    this.editor.composition.attachments.forEach((a) =>{
      if(a.attributes.values.contentType === 'text/html'){
        this.tableCounter++
      } 
    })
  }

  incrementTableCounter(){
    this.tableCounter++
    this.disableAttachTableButton()
  }

  decrementTableCounter(){
    this.tableCounter--
    this.disableAttachTableButton()
  }

  disableAttachTableButton(){
    const button = this.editor.element['toolbarElement']
                        .querySelector(`[data-trix-button-group = "table-tools"]`)
                        .querySelector(`[data-trix-attribute="attach"]`)
    
    if (this.tableCounter >= 1){
      button.disabled = true
    }else{
      button.disabled = false
    }
  }

  createCountMessageDiv(){
    const dataControllerAttribute = this.element?.getAttribute('data-controller')
  
    if(dataControllerAttribute === 'rich-text-table'){
      const divElement = document.createElement("div");
      divElement.classList.add('text-right')
      divElement.classList.add('trix-counter')
  
      this.element.appendChild(divElement)
    }
  }

  setCount(trixEditor) {
    // We need to get the length of the input field as the trix editor
    // values do not include the HMTL tags used for formatting
    const length = this.lengthInput(trixEditor.parentElement.querySelector('input'))
    const maxLength = this.getLimit(trixEditor);
    const counterArea = trixEditor.nextElementSibling;

    if (maxLength && maxLength > 0) {
      counterArea.innerHTML = length + ' / ' + maxLength;
  
      if (length > maxLength) {
        counterArea.classList.add("text-danger");
        trixEditor.classList.add("text-danger");
        trixEditor.style.borderColor = "#cc0000";
      } else {
        counterArea.classList.remove("text-danger");
        trixEditor.classList.remove("text-danger");
        trixEditor.style.borderColor = "#bbb";
      }
    } else {
      counterArea.innerHTML = length;
    }
  }
  
  lengthInput(input){
    let inputElement = $(input.value)
    if (!inputElement.find('figure[data-trix-attachment]').length){
      return input.value.length
    }

    return input.value.length - inputElement.find('figure[data-trix-attachment]')[0].outerHTML.length
  }

  getLimit() {
    if (this.maxLength && this.maxLength > 0) {
      return this.maxLength
    } else {
      return 0
    }
  }
  
  attachTable(e) {
    if(this.tableCounter >= 1){
      e.target.disabled = true;
      return
    }

    axios({url: '/tables', method: 'POST'})
      .then((response) => {
				this.insertTable(response.data)
			})
  }
    
  insertTable(tableAttachment) {
    this.attachment = new Trix.Attachment(tableAttachment)
    this.editor.insertAttachment(this.attachment)
    this.element.focus()
    this.disableAttachTableButton()
  }

  get maxLength() {
    return this.data.get("max-length-value")
  }
}